import AwardIcon from './component.jsx'
export default AwardIcon
